import { NAV_LINKS, SITE, SOCIALS, STORES } from "../data/site";
import { SOCIAL_ICONS } from "./Social";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-800/80 bg-[#08090D]"
    >
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/brand/logo-circular-t.png"
                alt="Sandstorm Trading circular logo"
                width="800"
                height="810"
                className="h-10 w-auto"
              />
              <div>
                <p className="font-display text-base font-bold uppercase tracking-wide text-white">
                  Sandstorm Trading
                </p>
                <p className="text-xs font-medium text-amber-300/90">{SITE.tagline}</p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
              An independent online trading card and collectibles business, serving
              collectors and players through established marketplaces.
            </p>
            <p className="mt-4 font-mono text-sm text-amber-300" data-testid="footer-domain">
              {SITE.domain}
            </p>
          </div>
          <nav aria-label="Footer">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.href}
                    data-testid={`footer-nav-${l.id}`}
                    className="text-sm text-zinc-500 transition-colors hover:text-amber-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Storefronts">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">Shop</p>
            <ul className="mt-4 space-y-2.5">
              {STORES.map((s) => (
                <li key={s.id}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-store-${s.id}`}
                    className="text-sm text-zinc-500 transition-colors hover:text-amber-300"
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Social channels">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">Follow</p>
            <ul className="mt-4 space-y-2.5">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.id];
                return (
                  <li key={s.id}>
                    <a
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`footer-social-${s.id}`}
                      className="inline-flex items-center gap-2 text-sm text-zinc-500 transition-colors hover:text-amber-300"
                    >
                      <Icon className="h-4 w-4 text-amber-400/70" />
                      {s.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-zinc-800/60 pt-6 sm:flex-row">
          <p className="text-xs text-zinc-600" data-testid="footer-copyright">
            © {year} Sandstorm Trading. All rights reserved.
          </p>
          <p className="text-xs font-medium tracking-wide text-zinc-600">{SITE.tagline}</p>
        </div>
      </div>
    </footer>
  );
};
